(() => {
  if (window.HoKSlideshowCountdownLoaded) return;
  window.HoKSlideshowCountdownLoaded = true;

  const pad = (value) => String(value).padStart(2, '0');

  const formatRemaining = (ms) => {
    if (ms <= 0) return null;
    const totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    if (days > 0) return `${days}d ${pad(hours)}h ${pad(minutes)}m`;
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };

  const activateLiveCta = (root) => {
    if (root.dataset.liveActivated === 'true') return;
    const href = root.dataset.liveHref || '';
    const label = root.dataset.liveLabel || 'Shop now';
    if (!href) return;

    root.dataset.liveActivated = 'true';
    root.replaceChildren();
    const link = document.createElement('a');
    link.href = href;
    link.className = 'button button--primary hok-slideshow-countdown__live';
    link.textContent = label;
    root.appendChild(link);

    const slide = root.closest('.slideshow__slide');
    const media = slide?.querySelector('.slideshow__media');
    if (media && !media.querySelector('.hok-slideshow-media-link')) {
      media.classList.add('slideshow__media--linked');
      const mediaLink = document.createElement('a');
      mediaLink.href = href;
      mediaLink.className = 'hok-slideshow-media-link full-unstyled-link';
      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.textContent = label;
      mediaLink.appendChild(hidden);
      media.prepend(mediaLink);
    }
  };

  const tick = (root) => {
    const releaseAt = root.dataset.releaseAt || '';
    const releaseMs = Date.parse(releaseAt);
    if (!releaseAt || Number.isNaN(releaseMs)) return;

    const remaining = releaseMs - Date.now();
    if (remaining <= 0) {
      activateLiveCta(root);
      return;
    }

    const timeEl = root.querySelector('[data-countdown-time]');
    if (timeEl) timeEl.textContent = formatRemaining(remaining) || '--:--:--';
  };

  const init = (scope = document) => {
    const nodes = scope.querySelectorAll('[data-hok-slideshow-countdown]:not([data-live-activated="true"])');
    nodes.forEach((root) => {
      if (root.querySelector('.hok-slideshow-countdown__live')) return;
      tick(root);
    });
  };

  init();
  window.setInterval(() => init(), 1000);

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
